import { render, staticRenderFns } from "./VipManagement.vue?vue&type=template&id=8965dd1e&scoped=true"
import script from "./VipManagement.vue?vue&type=script&lang=js"
export * from "./VipManagement.vue?vue&type=script&lang=js"
import style0 from "./VipManagement.vue?vue&type=style&index=0&id=8965dd1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8965dd1e",
  null
  
)

export default component.exports